import { create } from 'zustand';

interface PasskeyManagementStoreState {
    isOpen: boolean;
    /**
     * Set when the passkey manager sent the user through the Connected Wallet
     * (eip712) reauthentication it requires. When that window resolves, the
     * manager reopens automatically if the wallet authority is now active —
     * without this the user just sees their login switch from OAuth to wallet
     * and has no idea why. Cleared unconditionally once the window resolves.
     */
    reopenAfterWalletAuthority: boolean;
    open: () => void;
    close: () => void;
    markReopenAfterWalletAuthority: () => void;
    clearReopenAfterWalletAuthority: () => void;
}

export const usePasskeyManagementStore = create<PasskeyManagementStoreState>(
    (set) => ({
        isOpen: false,
        reopenAfterWalletAuthority: false,
        open: () => set({ isOpen: true }),
        close: () => set({ isOpen: false }),
        markReopenAfterWalletAuthority: () =>
            set({ reopenAfterWalletAuthority: true }),
        clearReopenAfterWalletAuthority: () =>
            set({ reopenAfterWalletAuthority: false }),
    }),
);
